import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CreatableSelect from 'react-select/creatable';
import Select from '../../../../components/widgets/Select';
import selectCss from '../../../../components/widgets/ReactSelectOverrides.css';
import css from './style.css';

const MENU_PORTAL_TARGET = typeof document !== 'undefined' ? document.body : undefined;

const toArray = value => {
    if (Array.isArray(value)) return value;
    return value !== null && value !== undefined && value !== '' ? [value] : [];
};

const MultiValueSelect = ({
    values = [],
    options = [],
    multi = false,
    invalid = false,
    disabled = false,
    isCreatable = false,
    editCondition,
}) => {
    const optionMap = useMemo(() => {
        const map = new Map();
        options.forEach(option => map.set(option.value, option));
        return map;
    }, [options]);

    const resolvedValues = useMemo(
        () => toArray(values).map(value => optionMap.get(value) || { label: String(value), value }),
        [values, optionMap]
    );

    const handleChange = selected => {
        if (multi) {
            editCondition('values', (selected || []).map(option => option.value));
        } else if (selected) {
            editCondition('values', selected.value);
        }
    };

    const Component = isCreatable ? CreatableSelect : Select;

    return (
        <Component
            className={classNames(selectCss.singularSelect, css.conditionSelect, css.fill, {
                [selectCss.error]: invalid,
            })}
            classNamePrefix="Select"
            isDisabled={disabled}
            isMulti={multi}
            isClearable={false}
            value={multi ? resolvedValues : resolvedValues[0] || null}
            options={options}
            onChange={handleChange}
            menuPortalTarget={MENU_PORTAL_TARGET}
        />
    );
};

MultiValueSelect.propTypes = {
    values: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        PropTypes.string,
        PropTypes.number,
    ]),
    options: PropTypes.arrayOf(
        PropTypes.shape({ value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), label: PropTypes.string })
    ),
    multi: PropTypes.bool,
    invalid: PropTypes.bool,
    disabled: PropTypes.bool,
    isCreatable: PropTypes.bool,
    editCondition: PropTypes.func.isRequired,
};

export default MultiValueSelect;
